export default __webpack_public_path__ + "static/media/logo.4bb77ff7.png";